let prdPrevBtn = document.querySelectorAll(".slide-prev");
let prdNextBtn = document.querySelectorAll(".slide-next");
let sliderDot = document.querySelectorAll(".slider-dots span");
let sliderWrap = document.querySelector(".product-media-content");
let PrdVariantOptions = document.querySelectorAll(".variants-option input");
const mediaScroll = (el, dir, scrollVal) => {
  let parentWrapper = el
    .closest(".product-container")
    .querySelector(".product-media-content");
  let currentSlide = parentWrapper.querySelector(
    ".product-media-container.active"
  );
  let slideWidth = currentSlide.getBoundingClientRect().width;
  dir
    ? (parentWrapper.scrollLeft -= slideWidth)
    : (parentWrapper.scrollLeft += slideWidth);
  scrollVal
    ? (parentWrapper.scrollLeft = slideWidth * (Number(scrollVal) - 1))
    : "";
};
sliderWrap.addEventListener("scroll", function () {
  let activeIndex = Math.floor(
    this.scrollLeft / Math.floor(this.getBoundingClientRect().width)
  );
  this.querySelectorAll(".product-media-container").forEach(function (el, ind) {
    if (ind == activeIndex) {
      el.classList.add("active");
    } else {
      el.classList.remove("active");
    }
  });
  sliderDot.forEach(function (el, ind) {
    if (ind == activeIndex) {
      el.classList.add("active");
      el.closest(".slider-dots").scrollLeft =
        el.getBoundingClientRect().width * ind;
    } else {
      el.classList.remove("active");
    }
  });
});
prdPrevBtn.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    mediaScroll(el, true);
  });
});
prdNextBtn.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    mediaScroll(el, false);
  });
});
sliderDot.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    mediaScroll(el, null, el.dataset.index);
  });
});
/////////////////////updating variant images
function updateVariantImage(variant) {
  let media = document.querySelectorAll(".product-media-container");
  media.forEach((el, ind) => {
    let variantOpt = el.querySelector("img").getAttribute("alt").toLowerCase();
    console.log(variantOpt,"here");
    if (variantOpt == variant.toLowerCase()) {
      console.log(ind)
      mediaScroll(el, null, ind+1);
    }
  });
}
PrdVariantOptions.forEach((el, ind) => {
  console.log(el)
  el.addEventListener("change", function () {
    if (el.checked) {
      let value = el.value.toLowerCase();
      updateVariantImage(value);
    }
  });
});
